/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import PageBanner from '../../components/PageBanner';
import SEO from '../../components/SEO';
import SectionSidebar from '../../components/SectionSidebar';
import { Container, Typography, Box, Grid, Button, Chip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import SpaIcon from '@mui/icons-material/Spa';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PublicIcon from '@mui/icons-material/Public';
import TempleHinduIcon from '@mui/icons-material/TempleHindu';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import StarIcon from '@mui/icons-material/Star';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { Link as RouterLink } from 'react-router-dom';

const GOLD = '#d4af37';

export default function SpecialPoojas() {
  const specialPoojas = [
    {
      name: 'Vishnu Pooja',
      description: 'Sacred worship dedicated to Lord Vishnu for divine protection and blessings',
      price: 11000,
      gradient: 'linear-gradient(135deg, #1E88E5, #1565C0)',
      Icon: TempleHinduIcon,
    },
    {
      name: 'Chathussatha Pooja',
      description: 'Grand ceremonial worship involving elaborate rituals and offerings',
      price: 27000,
      gradient: 'linear-gradient(135deg, #8E24AA, #6A1B9A)',
      Icon: SpaIcon,
    },
    {
      name: 'Siva Parvathi Pooja',
      description: 'Devotional worship of Lord Shiva and Goddess Parvathi for family harmony and blessings',
      price: 1000,
      gradient: 'linear-gradient(135deg, #D32F2F, #B71C1C)',
      Icon: SpaIcon,
    },
    {
      name: 'Paripala Payasam',
      description: 'Sacred payasam offering prepared with traditional rituals and devotion',
      price: 1000,
      gradient: 'linear-gradient(135deg, #FB8C00, #EF6C00)',
      Icon: VolunteerActivismIcon,
    },
    {
      name: 'Sudarsana Homam',
      description: 'Powerful fire ritual invoking Lord Sudarsana for protection and removal of negative energies',
      price: 1000,
      gradient: 'linear-gradient(135deg, #F4511E, #D84315)',
      Icon: SpaIcon,
    },
    {
      name: 'Navarathri Vilakk',
      description: 'Grand lamp offering performed during the nine auspicious nights of Navarathri',
      price: 17000,
      gradient: 'linear-gradient(135deg, #43A047, #2E7D32)',
      Icon: TempleHinduIcon,
    },
    {
      name: 'Valiya Pushpanjali',
      description: 'Elaborate floral offering with sacred chanting and special mantras for divine grace',
      price: 3000,
      gradient: 'linear-gradient(135deg, #E91E63, #C2185B)',
      Icon: SpaIcon,
    },
    {
      name: 'Thrikaala Pooja',
      description: 'Sacred worship performed at all three auspicious times of the day',
      price: 3500,
      gradient: 'linear-gradient(135deg, #5E35B1, #4527A0)',
      Icon: TempleHinduIcon,
    },
  ];

  const contacts = [
    { icon: PhoneIcon, title: 'Phone Booking', info: '0496 2690751' },
    { icon: EmailIcon, title: 'Email Us', info: 'info@kottakovilakam.com' },
    { icon: BookOnlineIcon, title: 'Online Booking', info: 'Book instantly', hasButton: true },
  ];

  return (
    <Box sx={{ bgcolor: '#fafaf8', minHeight: '100vh' }}>
      <SEO title="Special Poojas — Kottayil Temple | വിശേഷ പൂജകൾ" description="Special poojas and ceremonies at Kottayil Temple (Kotta-Kovilakam Kshethram). Ganapathi Homam, Sahasranamam, Laksharchana, and other sacred rituals." path="/poojas/special" keywords="special poojas, Kottayil temple special pooja, homam, ganapathi homam, sahasranamam, laksharchana, special ceremonies, വിശേഷ പൂജ, കൊട്ടയിൽ ക്ഷേത്രം, ഹോമം, ഗണപതി ഹോമം, സഹസ്രനാമം" />
      <PageBanner title="Special Poojas" />
      <Container maxWidth="lg" sx={{ mt: { xs: -4, md: -6 }, position: 'relative', zIndex: 2, pb: 10 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8} lg={9}>

            {/* ══════ VIBRANT HERO ══════ */}
            <Box sx={{
              borderRadius: '24px', overflow: 'hidden', mb: 3.5,
              background: 'linear-gradient(135deg, #312e81 0%, #4f46e5 50%, #6366f1 100%)',
              position: 'relative',
            }}>
              <Box sx={{ position: 'absolute', inset: 0, opacity: 0.07, backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)', backgroundSize: '20px 20px' }} />
              <Box sx={{ position: 'absolute', top: -60, right: -60, width: 200, height: 200, borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)' }} />
              <Box sx={{ position: 'absolute', bottom: -40, left: -40, width: 160, height: 160, borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%)' }} />

              <Box sx={{ px: { xs: 3, sm: 4 }, pt: { xs: 3.5, sm: 4 }, pb: { xs: 4, sm: 5 }, position: 'relative', zIndex: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, mb: 2.5 }}>
                  <Box sx={{
                    width: 64, height: 64, borderRadius: '20px',
                    bgcolor: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)',
                    border: '2px solid rgba(255,255,255,0.25)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <AutoAwesomeIcon sx={{ fontSize: 32, color: '#fff' }} />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Chip label="Sacred Rituals" size="small" icon={<VolunteerActivismIcon sx={{ fontSize: 14, color: '#fff !important' }} />} sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: '#fff', fontWeight: 700, fontSize: '0.7rem', mb: 1, height: 24, backdropFilter: 'blur(8px)' }} />
                    <Typography sx={{ fontWeight: 900, fontSize: { xs: '1.5rem', sm: '1.8rem' }, color: '#fff', lineHeight: 1.2 }}>
                      Special Poojas
                    </Typography>
                  </Box>
                </Box>
                <Typography sx={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.8)', lineHeight: 1.8, maxWidth: 600 }}>
                  Special poojas performed at Muchukunnu Sri Kotta-Kovilakam Kshethram with traditional tantric rituals and sacred offerings for divine blessings.
                </Typography>
              </Box>
            </Box>

            {/* ══════ POOJA CARDS GRID ══════ */}
            <Grid container spacing={2.5} sx={{ mb: 3.5 }}>
              {specialPoojas.map((pooja, idx) => (
                <Grid item xs={12} sm={6} key={idx}>
                  <Box sx={{
                    bgcolor: '#fff', borderRadius: '24px',
                    border: '1px solid rgba(0,0,0,0.06)',
                    boxShadow: '0 4px 24px rgba(0,0,0,0.04)',
                    overflow: 'hidden',
                    transition: 'all 350ms cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: '0 20px 50px rgba(0,0,0,0.08)',
                      '& .poojaOrb': { transform: 'scale(1.15) rotate(8deg)' },
                    },
                  }}>
                    {/* Color header */}
                    <Box sx={{
                      background: pooja.gradient,
                      px: { xs: 2.5, sm: 3 }, py: 2,
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box className="poojaOrb" sx={{
                          width: 40, height: 40, borderRadius: '12px',
                          bgcolor: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)',
                          border: '2px solid rgba(255,255,255,0.25)',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          transition: 'transform 400ms cubic-bezier(0.34, 1.56, 0.64, 1)',
                        }}>
                          <pooja.Icon sx={{ fontSize: 20, color: '#fff' }} />
                        </Box>
                        <Typography sx={{ fontWeight: 800, fontSize: '0.95rem', color: '#fff' }}>
                          {pooja.name}
                        </Typography>
                      </Box>
                      <Chip
                        className="notranslate"
                        label={`\u20B9${pooja.price.toLocaleString()}`}
                        size="small"
                        sx={{
                          bgcolor: 'rgba(255,255,255,0.2)',
                          color: '#fff',
                          fontWeight: 800,
                          fontSize: '0.72rem',
                          height: 26,
                          backdropFilter: 'blur(8px)',
                        }}
                      />
                    </Box>

                    {/* Description */}
                    <Box sx={{ px: { xs: 2.5, sm: 3 }, py: 2.5 }}>
                      <Typography sx={{ fontSize: '0.8rem', color: '#64748b', lineHeight: 1.7 }}>
                        {pooja.description}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>



            {/* ══════ DARK SLATE FOOTER — BOOKING INFO ══════ */}
            <Box sx={{
              borderRadius: '24px', overflow: 'hidden', position: 'relative',
              background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
            }}>
              <Box sx={{ position: 'absolute', inset: 0, opacity: 0.03, backgroundImage: 'radial-gradient(circle, #fff 1px, transparent 1px)', backgroundSize: '20px 20px' }} />
              <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg, transparent, ${GOLD}, transparent)` }} />
              <Box sx={{ position: 'absolute', bottom: -30, right: -30, width: 160, height: 160, borderRadius: '50%', background: 'radial-gradient(circle, rgba(212,175,55,0.08) 0%, transparent 70%)' }} />

              <Box sx={{ px: { xs: 3, sm: 4 }, py: 3.5, position: 'relative', zIndex: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                  <Box sx={{
                    width: 40, height: 40, borderRadius: '12px',
                    background: `linear-gradient(135deg, ${GOLD}, #f59e0b)`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 4px 16px rgba(212,175,55,0.3)',
                  }}>
                    <BookOnlineIcon sx={{ fontSize: 20, color: '#fff' }} />
                  </Box>
                  <Typography sx={{ fontWeight: 800, fontSize: { xs: '0.88rem', md: '1rem' }, color: '#fff' }}>
                    Booking Information
                  </Typography>
                </Box>

                {/* Contact cards */}
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  {contacts.map((c, idx) => (
                    <Grid item xs={12} sm={4} key={idx}>
                      <Box sx={{
                        px: 2, py: 2, borderRadius: '18px',
                        bgcolor: 'rgba(255,255,255,0.04)',
                        border: '1px solid rgba(255,255,255,0.06)',
                        textAlign: 'center',
                        transition: 'all 300ms ease',
                        '&:hover': {
                          bgcolor: 'rgba(255,255,255,0.07)',
                          transform: 'translateY(-3px)',
                        },
                      }}>
                        <Box sx={{
                          width: 40, height: 40, borderRadius: '12px', mx: 'auto', mb: 1.5,
                          background: `linear-gradient(135deg, ${GOLD}, #f59e0b)`,
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          boxShadow: '0 4px 16px rgba(212,175,55,0.25)',
                        }}>
                          <c.icon sx={{ fontSize: 20, color: '#fff' }} />
                        </Box>
                        <Typography sx={{ fontWeight: 700, fontSize: '0.82rem', color: '#fff', mb: 0.3 }}>
                          {c.title}
                        </Typography>
                        {c.hasButton ? (
                          <Button
                            component={RouterLink} to="/poojas/booking"
                            size="small"
                            sx={{
                              mt: 0.5, px: 2, py: 0.5, borderRadius: '10px',
                              background: `linear-gradient(135deg, ${GOLD}, #f59e0b)`,
                              color: '#fff', fontWeight: 700, fontSize: '0.7rem',
                              textTransform: 'none',
                              '&:hover': { boxShadow: '0 4px 16px rgba(212,175,55,0.35)' },
                            }}
                          >
                            Book Now
                          </Button>
                        ) : (
                          <Typography sx={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.45)', wordBreak: 'break-all' }}>
                            {c.info}
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  ))}
                </Grid>

                {/* Important notes */}
                <Box sx={{
                  px: 2.5, py: 2, borderRadius: '16px',
                  bgcolor: 'rgba(212,175,55,0.05)',
                  border: '1px solid rgba(212,175,55,0.1)',
                }}>
                  <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: GOLD, mb: 1.5 }}>
                    Important Notes
                  </Typography>
                  {[
                    'Advance booking required (minimum 2 days)',
                    'Prices may vary based on requirements',
                    'Prasadam will be provided after the pooja',
                  ].map((note, idx) => (
                    <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: idx < 2 ? 0.8 : 0 }}>
                      <CheckCircleOutlineIcon sx={{ fontSize: 14, color: GOLD, flexShrink: 0 }} />
                      <Typography sx={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.6 }}>
                        {note}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>

          </Grid>

          <Grid item xs={12} md={4} lg={3}>
            <SectionSidebar sectionKey="poojas" activePath="/poojas/special" />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
